<template>
  <div>
    <h2>Jetzt <span class="text-blue">kostenlos</span> auf TeamWaizmann anmelden</h2>
    Sie können sich <span class="text-blue">kostenlos</span> auf TeamWaizmann anmelden und so kostenlos neue WaizmannTabellen anfordern.
    Über {{ dataplugin.getData('zahnarzt') }} Zahnärzte nutzen bereits die WaizmannTabelle.
  
  <span v-if="showSocialLogin">
    <v-row  v-if="!isLoggedIn" class="mt-2">
          <v-col cols="12" md="6">
            <v-btn
      color="#DB4437" 
      @click="loginWithGoogle"
      class="text-center white--text"
      block
      justify="center"
    >
      <v-icon class="mr-2">mdi-google</v-icon>
      Mit Google anmelden
    </v-btn>
    
          </v-col>
  
          <v-col cols="12" md="6" v-if="showFacebookLogin">
            <v-btn
              color="primary"
              @click="loginWithFacebook"
             
              block
              variant="elevated"
            >
              <template v-slot:prepend>
                <v-icon>mdi-facebook</v-icon>
              </template>
              Mit Facebook anmelden
            </v-btn>
          </v-col>
        </v-row>
    <v-row class="my-4">
      <v-col cols="12" md="12">
        <div class="divider-container">
        <v-divider></v-divider>
        <span class="divider-text"><b>oder</b></span>
        <v-divider></v-divider>
      </div>
      </v-col>
    </v-row>
    </span>
    <v-form ref="form" v-model="valid">
            <v-row>
  
    <v-col cols="12" md="122">
      <v-text-field
        v-model="userdata.user_email"
        :error-messages="formError.user_email"
        @blur="validateUserEmail"
        @input="validateForm"
        @click="showAddress = true"
        label="E-Mail"
        
      ></v-text-field>
    </v-col>
  
  
    </v-row>
          <v-row>
            <v-col cols="12" md="12">
      <v-text-field
        v-model="userdata.user_firma"
        label="Name der Praxis"
        
      ></v-text-field>
    </v-col>
    </v-row>
            <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="userdata.user_vorname"
                :error-messages="formError.user_vorname"
                @input="validateForm"
                label="Vorname"
                
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" md="8">
              <v-text-field
                v-model="userdata.user_name"
                :error-messages="formError.user_name"
                @input="validateForm"
                label="Name"
                
              ></v-text-field>
            </v-col>
  
          </v-row>
  
  <span v-if="showAddress">
          <v-row>
            <v-col cols="12" md="10">
              <v-text-field
                v-model="userdata.user_strasse"
                :error-messages="formError.user_strasse"
                @input="validateForm"
                label="Straße"
                
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" md="2">
              <v-text-field
                v-model="userdata.user_hsnr"
                label="Hsnr."
              ></v-text-field>
            </v-col>
  
           
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="userdata.user_plz"
                :error-messages="formError.user_plz"
                @input="validateForm"
                label="PLZ"
                
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" md="10">
              <v-text-field
                v-model="userdata.user_ort"
                :error-messages="formError.user_ort"
                @input="validateForm"
                label="Ort"
                
              ></v-text-field>
            </v-col>
          </v-row>
   
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="userdata.user_pass_neu1"
                :error-messages="formError.user_pass_neu1"
                @input="validateForm"
                label="Passwort"
                type="password"
                required
              ></v-text-field>
            </v-col>
  
            <v-col cols="12" md="6">
              <v-text-field
                v-model="userdata.user_pass_neu2"
                :error-messages="formError.user_pass_neu2"
                @input="validateForm"
                label="Passwort wiederholen"
                type="password"
                required
              ></v-text-field>
            </v-col>
          </v-row>
  </span>
          <v-btn  color="primary" @click="insertUserData">jetzt kostenlos anmelden</v-btn>
        
          <v-row v-if="showFormError">
               
               <v-col cols="12" class="my-2" >
                 <ul>
                   <li v-for="error in formErrors" :key="error">
                     <span v-if="error" class="error">{{ error }}</span>
                   </li>
                 </ul>
               </v-col>
             </v-row>
        </v-form>
      </div>
  </template>
  
  <script setup>
  import {  ref, inject,defineProps,onMounted } from "vue";
  
  import { useUserStore } from '@/stores/userStore';
  import regexHelper from '@/plugins/regexHelper';
  import { useRouter } from 'vue-router'; // Fehlender Import könnte Probleme verursachen
  const router = useRouter();
  const baseCalls = inject('baseCalls')
  const loaderStore = inject('loaderStore')
  
  const errorStore = inject('errorStore');
  const successStore = inject('successStore');
  const dataplugin = inject('dataplugin');
  const userStore = useUserStore();
  
  const props = defineProps({
       newRoute: {
         type: [String, Object]
       }
     });
  const showAddress = ref(false);
  console.log(props.newRoute);
  
  const userdata = ref({
    user_name: '',
    user_vorname: '',
    user_firma: '',
    user_email: '',
    user_strasse: '',
    user_hsnr: '',
    user_plz: '',
    user_ort: '',
    user_pass_neu1: '',
    user_pass_neu2: '',
  });
  const form = ref(null);
  const valid = ref(false);
  const formError = ref({
    user_email: '',
  });
  const showFormError = ref(false);
  const formErrors = ref([]);
  const submitStarted = ref(false);
  const isLoggedIn = ref(false);
  const showSocialLogin = ref(true);
  const showFacebookLogin = ref(true);
  
  /* global google */
  
  function validateUserEmail() {
     const [showError, textError] = regexHelper.validateEmail(userdata.value.user_email);
  
    if (showError === false) {
      // E-Mail ist gültig
      formError.value.user_email = '';
      return true;
    } else {
      // E-Mail ist ungültig, validationResult enthält die Fehlermeldung
      formError.value.user_email = textError;
      return false;
    }
  }
  
  function validateForm() {
    // Initialisiere das Fehlerobjekt
    showAddress.value = true;
    formErrors.value = [];
    const errors = {
      user_email: '',
      user_pass_neu1: '',
      user_pass_neu2: '',
      user_vorname: '',
      user_name: '',
      user_strasse: '',
      user_plz: '',
      user_ort: ''
    };
  
    // Hilfsfunktion zur Fehlerbehandlung
    function addError(field, message) {
     
      if (submitStarted.value) {
        errors[field] = message;
      }
      formErrors.value.push(message);
    }
  
    // Validierung der Eingabefelder
    const [showError, textError] = regexHelper.validateEmail(userdata.value.user_email);
    if (showError) addError('user_email', textError);
  
    if (userdata.value.user_pass_neu1.length < 6) {
      addError('user_pass_neu1', 'Passwort muss mindestens 6 Zeichen lang sein');
    }
  
    if (userdata.value.user_pass_neu1 !== userdata.value.user_pass_neu2) {
      addError('user_pass_neu2', 'Passwörter stimmen nicht überein');
    }
  
    if (!userdata.value.user_vorname) {
      addError('user_vorname', 'Bitte geben Sie Ihren Vornamen ein');
    }
  
    if (!userdata.value.user_name) {
      addError('user_name', 'Bitte geben Sie Ihren Namen ein');
    }
  
    if (!userdata.value.user_strasse) {
      addError('user_strasse', 'Bitte geben Sie Ihre Straße ein');
    }
  
    
  
    if (userdata.value.user_plz.length != 5) {
      addError('user_plz', 'PLZ 5-stellig ein');
    }
  
    if (!userdata.value.user_ort) {
      addError('user_ort', 'Bitte geben Sie Ihre Ortschaft ein');
    }
  
    // Setze die Fehler im formError-Objekt
    formError.value = errors;
  
    // Überprüfe, ob Fehler vorhanden sind
    showFormError.value = formErrors.value.length > 0 && submitStarted.value;
    if (!showFormError.value) {
      submitStarted.value = false;
    }
  }
  function hasErrors() {
   
   showFormError.value = Object.values(formErrors.value).some(error => error !== '')
   return Object.values(formErrors.value).some(error => error !== '')
   
  }
  async function insertUserData() {
  
      // Formular validieren
      submitStarted.value = true;
      validateForm()
  
    // Prüfen, ob es Fehler gibt
    if (hasErrors()) {
      console.log('Fehler im Formular, Login nicht möglich')
      return
    }
  
    
    loaderStore.setLoader(true, "Ihr Account wird erstellt...");
    
    try {
      const payload = {
        ...userdata.value,
        action: 'insertuser'
      };
      
      const response = await baseCalls.userPost(payload);
      
      if (response.data && response.data.success && response.data.user) {
        loaderStore.setLoader(false, "");
        successStore.setSuccess(
          true,
          "Gespeichert",
          "Ihr Account wurde erfolgreich angelegt"
        );
        userStore.setUser(response.data.user);
        if (props.newRoute) {
          router.push(props.newRoute);
        }
      } else {
        throw new Error(response.data.message || "Fehler beim Anlegen des Accounts");
      }
    } catch (err) {
      errorStore.setError(
        err.message || "Beim Anlegen des Accounts ist ein Fehler aufgetreten"
      );
      console.error("Fehler beim Anlegen des Accounts:", err);
    } finally {
      loaderStore.setLoader(false);
    }
  }
  async function startLoginGoogle(payload) {
    // Formular validieren
    submitStarted.value = true;
  
    // Prüfen, ob es Fehler gibt
    let data = {
      user_email: payload.email,
      user_google_id: payload.sub,
      user_name: payload.name,
      action: 'startLoginGoogle'
    }
  
    // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
    console.log('google Login wird gestartet...', data) 
    // Ladezustand aktivieren
    loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");
  
    try {
      const response = await baseCalls.userPost(data);
      if (response.data.user ) {
        console.log('Benutzerdaten geladen:', response.data);
        isLoggedIn.value = true;
        userStore.setUser(response.data.user )
        loaderStore.setLoader(false);
        if (props.newRoute) {
            // Timeout von 1 Sekunde vor der Weiterleitung
            router.push(props.newRoute);
        }
      } else {
        errorStore.setError(true, response.data.message);
      }
    } catch (err) {
     
      errorStore.setError(true, 'Es ist ein Fehler aufgetreten');
      console.error('API-Fehler:', err);
    } finally {
  
      loaderStore.setLoader(false);
    }
  }
  
  async function countSocialLogins(what) {
    // Formular validieren
    let data = {
      what: what,
      action: 'countSocialLogins'
    }
    baseCalls.userPost(data);
  
    // Prüfen, ob es Fehler gibt
    
  }
  
  async function startLoginFacebook(payload) {
    // Formular validieren
    submitStarted.value = true;
  
    // Prüfen, ob es Fehler gibt
    let data = {
      user_email: payload.email,
      user_facebook_id: payload.id,
      user_name: payload.name,
      action: 'startLoginFacebook'
    }
  
    // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
    console.log('Login wird gestartet...')
    // Ladezustand aktivieren
    loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");
  
    try {
      const response = await baseCalls.userPost(data);
      if (response.data.user ) {
        console.log('Benutzerdaten geladen:', response.data);
        isLoggedIn.value = true;
        userStore.setUser(response.data.user )
        loaderStore.setLoader(false);
        if (props.newRoute) {
            // Timeout von 1 Sekunde vor der Weiterleitung
            router.push(props.newRoute);
        }
      } else {
        errorStore.setError(true, response.data.message);
      }
    } catch (err) {
     
      errorStore.setError(true, 'Es ist ein Fehler aufgetreten');
      console.error('API-Fehler:', err);
    } finally {
  
      loaderStore.setLoader(false);
    }
  }
  
  function loginWithGoogle() {
    countSocialLogins('google');
    console.log('Google Login gestartet');
    if (!googleInitialized || typeof google === 'undefined' || !google.accounts || !google.accounts.id) {
      errorStore.setError(true, 'Google-API ist nicht bereit oder konnte nicht geladen werden.');
      return;
    }
  
    google.accounts.id.prompt((notification) => {
      console.log('Google Login Notification:', notification);
      if (notification && notification.g) {
        const state = notification.g;
        const reason = notification.l;
        const success = notification.i;
  
        if (success === 'credential_returned') {
          console.log('Google Login erfolgreich:', notification);
          successStore.setSuccess(true, 'Google Login erfolgreich', 'Sie wurden erfolgreich bei Google eingeloggt.');
          return;
        }
        console.log(`Login Status: ${state}, Grund: ${reason}`);
  
        if (state === 'skipped') {
          if (reason === 'not_signed_in') {
            errorStore.setError(true, 'Sie sind nicht bei Google angemeldet. Bitte melden Sie sich zuerst in Ihrem Browser bei Google an und versuchen Sie es dann erneut.');
          } else if (reason === 'user_cancel' || reason === 'suppressed_by_user') {
            errorStore.setError(true, 'Sie haben den Google-Login abgebrochen.');
          } else if (reason === 'browser_not_supported') {
            errorStore.setError(true, 'Ihr Browser unterstützt den Google-Login nicht oder FedCM ist deaktiviert.');
          } else if (reason === 'unknown_reason' || !reason) {
            errorStore.setError(true, 'Bitte loggen Sie sich bei Google ein und versuchen Sie es erneut.');
          }
        } else if (state === 'dismissed') {
          errorStore.setError(true, 'Sie haben den Google-Login-Dialog geschlossen.');
        }
      } else if (notification && notification.error) {
          console.error("Google Prompt Error:", notification.error);
          errorStore.setError(true, `Fehler beim Google Login: ${notification.error.message || 'Unbekannter Fehler'}`);
      } else {
        console.warn("Unerwartete Google Login Notification Struktur:", notification);
        errorStore.setError(true, 'Ein unerwarteter Fehler ist beim Google-Login aufgetreten.');
      }
    });
  }
  function loginWithFacebook() {
    /* global FB */
    countSocialLogins('facebook');
    console.log("Facebook SDK wird initialisiert mit Version:", 'v18.0');
    FB.init({
      appId      : '563907036335909',
      cookie     : true,
      xfbml      : true,
      version    : 'v18.0'
    });
    console.log("Facebook SDK wurde initialisiert");
    FB.login(function(response) {
      if (response.authResponse) {
        // Hier wird der Access Token aus der Antwort verwendet, 
        // ohne ihn global zu setzen
        const accessToken = response.authResponse.accessToken;
        
        FB.api('/me', { access_token: accessToken, fields: 'name,email' }, function(userData) {
          if(userData.id){
           
            console.log('Good to see you, ' + userData.name + '.');
            console.log(userData);
            startLoginFacebook(userData);
          }
         
          // Hier kannst du mit dem Benutzer und seinem Token arbeiten
        });
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    }, { scope: 'public_profile,email' });
  }
  function handleGoogleCredentialResponse(response) {
    if (response.credential) {
      const googleData = parseJwt(response.credential);
      console.log('Google-Login erfolgreich:', googleData);
      startLoginGoogle(googleData);
    }
  }
  
  // JWT-Token dekodieren
  function parseJwt(token) {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      console.error('JWT dekodieren fehlgeschlagen', e);
      return null;
    }
  }
  
  let googleScriptLoaded = false;
  let googleInitialized = false;
  
  
  onMounted(() => {
    // Facebook SDK initialisieren
    window.fbAsyncInit = function() {
      console.log("Facebook SDK wird initialisiert mit Version:", 'v18.0');
      FB.init({
        appId      : '563907036335909',
        cookie     : true,
        xfbml      : true,
        version    : 'v18.0'
      });
      console.log("Facebook SDK wurde initialisiert");
    };
  
    // Facebook SDK laden
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      js.onload = function() {
        console.log("Facebook SDK erfolgreich geladen");
      };
      js.onerror = function() {
        console.error("Facebook SDK konnte nicht geladen werden");
      };
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  
    if (!window.onGoogleLibraryLoad) {
      window.onGoogleLibraryLoad = () => {
        console.log("Google Library jetzt geladen, Initialisierung startet...");
        if (typeof google !== 'undefined' && google.accounts && google.accounts.id && !googleInitialized) {
          try {
            google.accounts.id.initialize({
              client_id: '342725743050-hm0bol77jhgirib5gbueqtvp919vr7f6.apps.googleusercontent.com',
              callback: handleGoogleCredentialResponse,
              use_fedcm_for_prompt: true
            });
            googleInitialized = true;
            console.log("Google Identity Services initialisiert mit FedCM.");
          } catch (e) {
            console.error("Fehler bei der Initialisierung von Google Identity Services:", e);
          }
        } else if (googleInitialized) {
          console.log("Google Identity Services bereits initialisiert.");
        } else {
          console.error("Google-Objekt nicht verfügbar nach Skript-Ladung für Initialisierung.");
        }
      };
    }
  
    // Lade das Google-Skript, falls noch nicht geschehen
    loadGoogleScript();
  
  });
  
  function loadGoogleScript() {
    if (document.getElementById('google-script')) {
      console.log("Google-Skript-Tag existiert bereits.");
      if (typeof window.onGoogleLibraryLoad === 'function' && !googleInitialized) {
          console.log("Versuche onGoogleLibraryLoad manuell aufzurufen, da Skript schon da, aber nicht initialisiert.");
          window.onGoogleLibraryLoad();
      }
      return;
    }
  
    if (googleScriptLoaded) {
      console.log("Google-Skript-Ladeprozess bereits gestartet.");
      return;
    }
  
    console.log("Google-Skript wird geladen...");
    googleScriptLoaded = true;
    const script = document.createElement('script');
    script.id = 'google-script';
    script.src = 'https://accounts.google.com/gsi/client?v=latest';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  </script>
  <style scoped>
  .divider-container {
    display: flex;
    align-items: center;
    width: 100%;
  }
  
  .divider-text {
    padding: 0 16px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 16px;
  }
  </style>